export default __webpack_public_path__ + "static/hero-video-5-df96818dcb482c8674d5bd20e0393da5.mp4";